"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileById = exports.parameterById = exports.Lens = exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
const monocle_ts_1 = require("monocle-ts");
const ReadonlyRecord_1 = require("monocle-ts/Index/ReadonlyRecord");
exports.Type = prelude_1.t.type({
    production: prelude_1.t.union([prelude_1.t.number, prelude_1.t.NumberFromString]),
    product: prelude_1.t.union([prelude_1.t.number, prelude_1.t.NumberFromString]),
    preview_shorthash: prelude_1.t.string,
    preview_url: prelude_1.t.string,
    files: prelude_1.t.readonlyArray(prelude_1.t.readonlyRecord(prelude_1.t.string, prelude_1.t.string)),
    parameters: prelude_1.t.readonlyRecord(prelude_1.t.string, prelude_1.t.string),
    transientId: prelude_1.t.string
}, 'IALoadPreviewResponse');
exports.Lens = prelude_1.t.getLenses(exports.Type);
const parameterById = (id) => exports.Lens.parameters.composeOptional((0, ReadonlyRecord_1.indexReadonlyRecord)().index(id));
exports.parameterById = parameterById;
const filesTraversal = (0, monocle_ts_1.fromTraversable)(prelude_1.RA.Traversable)();
const fileById = (id) => exports.Lens.files.composeTraversal(filesTraversal).composeOptional((0, ReadonlyRecord_1.indexReadonlyRecord)().index(id));
exports.fileById = fileById;
//# sourceMappingURL=IALoadPreviewResponse.js.map